import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalStore } from '../store';
import '../Home/home.css';

// --- 1. DATA SOURCE: SEMUA KATEGORI AI ---
const aiCategories = [
    {
        title: "⭐ AI UTAMA (All-Rounder)",
        data: [
            { name: 'ChatGPT', desc: 'Asisten Multitasking & Logika Kode.', icon: '/assets/images/chatgpt.png', link: 'https://chat.openai.com' },
            { name: 'Claude', desc: 'Analisis Data & Penulisan Kreatif.', icon: '/assets/images/claude.png', link: 'https://claude.ai' },
            { name: 'Gemini', desc: 'Riset Cerdas & Integrasi Google.', icon: '/assets/images/gemini.png', link: 'https://gemini.google.com' },
            { name: 'Perplexity', desc: 'Search Engine Jawaban Instan.', icon: '/assets/images/perplexity.png', link: 'https://perplexity.ai' },
            { name: 'Amigo AI', desc: 'Asisten Cerdas Eksklusif Xyrons.', icon: '/assets/images/amigo.png', link: '#' },
            { name: 'Microsoft Copilot', desc: 'Produktivitas Terintegrasi Windows.', icon: '/assets/images/copilot.png', link: 'https://copilot.microsoft.com' },
            { name: 'Pi AI', desc: 'AI Personal Percakapan Natural.', icon: '/assets/images/pi.png', link: 'https://pi.ai' },
        ]
    },
    {
        title: "🏠 ARSITEKTUR & INTERIOR",
        data: [
            { name: 'Planner 5D', desc: 'Desain Rumah & Interior Cowok Modern.', icon: '/assets/images/planner5d.png', link: 'https://planner5d.com' },
            { name: 'RoomGPT', desc: 'Remodel Kamar Otomatis dari Foto.', icon: '/assets/images/roomgpt.png', link: 'https://www.roomgpt.io' },
            { name: 'Interior AI', desc: 'Ide Desain Ruangan Maskulin & Minimalis.', icon: '/assets/images/interiorai.png', link: 'https://interiorai.com' },
            { name: 'Homestyler', desc: 'Visualisasi Desain 3D Realistik.', icon: '/assets/images/homestyler.png', link: 'https://www.homestyler.com' },
            { name: 'Maketopia', desc: 'AI khusus Layout Denah Rumah.', icon: '/assets/images/maketopia.png', link: '#' },
        ]
    },
    {
        title: "🎬 VIDEO & DESAIN (Visual)",
        data: [
            { name: 'Midjourney', desc: 'Generator Artwork Fotorealistik.', icon: '/assets/images/midjourney.png', link: 'https://midjourney.com' },
            { name: 'Runway', desc: 'Transformasi Video Kreatif AI.', icon: '/assets/images/runway.png', link: 'https://runwayml.com' },
            { name: 'Leonardo AI', desc: 'Produksi Aset Visual & Game.', icon: '/assets/images/leonardo.png', link: 'https://leonardo.ai' },
            { name: 'Canva AI', desc: 'Desain Grafis Instan & Praktis.', icon: '/assets/images/canva.png', link: 'https://canva.com' },
            { name: 'Adobe Firefly', desc: 'Edit Gambar Standar Profesional.', icon: '/assets/images/firefly.png', link: 'https://adobe.com/firefly' },
            { name: 'VidMage AI', desc: 'Generator Video Cinematic.', icon: '/assets/images/vidmage.png', link: '#' },
            { name: 'Pika Labs', desc: 'Animasi Video dari Instruksi Teks.', icon: '/assets/images/pika.png', link: 'https://pika.art' },
            { name: 'HeyGen', desc: 'Avatar Video Bicara Realistis.', icon: '/assets/images/heygen.png', link: 'https://heygen.com' },
            { name: 'CapCut AI', desc: 'Editing Video Cerdas & Viral.', icon: '/assets/images/capcut.png', link: 'https://capcut.com' },
        ]
    },
    {
        title: "💰 BISNIS & MARKETING",
        data: [
            { name: 'Jasper AI', desc: 'Copywriting & Strategi Jualan.', icon: '/assets/images/jasper.png', link: 'https://jasper.ai' },
            { name: 'Durable AI', desc: 'Bangun Website dalam Detik.', icon: '/assets/images/durable.png', link: 'https://durable.co' },
            { name: 'Synthesia', desc: 'Presenter AI Tanpa Kamera.', icon: '/assets/images/synthesia.png', link: 'https://synthesia.io' },
            { name: 'Zapier AI', desc: 'Otomatisasi Alur Kerja Aplikasi.', icon: '/assets/images/zapier.png', link: 'https://zapier.com' },
            { name: 'Copy.ai', desc: 'Generator Konten Marketing.', icon: '/assets/images/copyai.png', link: 'https://copy.ai' },
            { name: 'AdCreative', desc: 'Materi Iklan Performa Tinggi.', icon: '/assets/images/adcreative.png', link: 'https://adcreative.ai' },
            { name: 'Beautiful.ai', desc: 'Slide Presentasi Modern & Pintar.', icon: '/assets/images/beautifulai.png', link: 'https://beautiful.ai' },
        ]
    },
    {
        title: "🚀 PRODUKTIVITAS & DEV",
        data: [
            { name: 'Notion AI', desc: 'Manajemen Tugas & Catatan.', icon: '/assets/images/notion.png', link: 'https://notion.so' },
            { name: 'Gamma AI', desc: 'Presentasi & Laman Otomatis.', icon: '/assets/images/gamma.png', link: 'https://gamma.app' },
            { name: 'Tome AI', desc: 'Storytelling & Pitch Deck.', icon: '/assets/images/tome.png', link: 'https://tome.app' },
            { name: 'GitHub Copilot', desc: 'Partner Coding Berbasis ML.', icon: '/assets/images/github.png', link: 'https://github.com' },
            { name: 'Cursor AI', desc: 'Editor Kode Masa Depan.', icon: '/assets/images/cursor.png', link: 'https://cursor.sh' },
            { name: 'Replit Agent', desc: 'Deploy Aplikasi dari Percakapan.', icon: '/assets/images/replit.png', link: 'https://replit.com' },
            { name: 'Otter.ai', desc: 'Notulensi Rapat & Transkrip.', icon: '/assets/images/otter.png', link: 'https://otter.ai' },
        ]
    }
];




export default function Home() {
    const navigate = useNavigate();
    const { user } = useGlobalStore();
    const [searchQuery, setSearchQuery] = useState("");
    const [isMenuOpen, setIsMenuOpen] = useState(false); // PERBAIKAN: Tadi ada typo 'onst'
    const [inputText, setInputText] = useState("");

    // --- STATE POSTINGAN ---
    const [posts, setPosts] = useState(() => {
        const saved = localStorage.getItem('xyrons_hub_posts');


        return saved ? JSON.parse(saved) : [
            {
                id: 1,
                user: "Xyron's",
                text: "Selamat datang di Xyron's Hub! Share ide AI kalian di sini.",
                likes: 5,
                comments: ["Gokil Websitenya!", "Mantap Ron!"],
                time: "Baru saja"
            }
        ];
    });

    useEffect(() => {
        localStorage.setItem('xyrons_hub_posts', JSON.stringify(posts));
    }, [posts]);

    // --- MUSIC LOGIC ---
    const [songs] = useState([
        { title: 'Surat Cinta Untuk Starla', artist: 'Virgoun', src: '/assets/audio/surat-cinta-untuk-starla.mp3', cover: '/logo-rony.png' },
        { title: 'Bukti', artist: 'Virgoun', src: '/assets/audio/bukti.mp3', cover: '/logo-rony.png' },
        { title: 'Saat Kau Telah Mengerti', artist: 'Virgoun', src: '/assets/audio/saat-kau-telah-mengerti.mp3', cover: '/logo-rony.png' },
        { title: 'Seluruh Nafas Ini', artist: 'Virgoun ft. Gisel', src: '/assets/audio/seluruh-nafas-ini.mp3', cover: '/logo-rony.png' },
        { title: 'Duka', artist: 'Last Child', src: '/assets/audio/duka.mp3', cover: '/logo-rony.png' },
        { title: 'Pedih', artist: 'Last Child', src: '/assets/audio/pedih.mp3', cover: '/logo-rony.png' },
        { title: 'Diary Depresiku', artist: 'Last Child', src: '/assets/audio/diary-depresiku.mp3', cover: '/logo-rony.png' },
        { title: 'Mangu', artist: 'Unknown', src: '/assets/audio/mangu.mp3', cover: '/logo-rony.png' },
        { title: 'Kita Usahakan Lagi', artist: 'Unknown', src: '/assets/audio/kita-usahakan-lagi.mp3', cover: '/logo-rony.png' },
        { title: 'Monolog', artist: 'Unknown', src: '/assets/audio/monolog.mp3', cover: '/logo-rony.png' },
        { title: 'Melukis Senja', artist: 'Unknown', src: '/assets/audio/melukis-senja.mp3', cover: '/logo-rony.png' },
        { title: 'Bahagia Lagi', artist: 'Unknown', src: '/assets/audio/bahagia-lagi.mp3', cover: '/logo-rony.png' },
        { title: 'Mengapa', artist: 'Vadly Nyonk', src: '/assets/audio/mengapa.mp3', cover: '/logo-rony.png' },
        { title: 'Bagaikan Bintang di Langit', artist: 'Putra Barera', src: '/assets/audio/bagaikan-bintang.mp3', cover: '/logo-rony.png' },
        { title: 'Melepas Masa Lajang', artist: 'Arvian Dwi', src: '/assets/audio/melepas-masa-lajang.mp3', cover: '/logo-rony.png' },
        { title: 'Sediakan Payung Sebelum Hujan', artist: 'Unknown', src: '/assets/audio/payung.mp3', cover: '/logo-rony.png' },
        { title: 'Mungkin Suatu Saat Nanti', artist: 'Mawar De Jongh', src: '/assets/audio/suatu-saat-nanti.mp3', cover: '/logo-rony.png' },
        { title: 'Mendampingi Dirimu', artist: 'Padi', src: '/assets/audio/mendampingi-dirimu.mp3', cover: '/logo-rony.png' },
        { title: 'Andai Engkau Tahu', artist: 'Vicetone', src: '/assets/audio/andai-engkau-tahu.mp3', cover: '/logo-rony.png' },
        { title: 'Resah Jadi Luka', artist: 'Daun Jatuh', src: '/assets/audio/resah-jadi-luka.mp3', cover: '/logo-rony.png' },
    ]);



    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isShuffle, setIsShuffle] = useState(false);
    const audioRef = useRef(null);

    const togglePlay = () => {
        if (!audioRef.current) return;
        if (isPlaying) audioRef.current.pause();
        else audioRef.current.play().catch(() => { });
        setIsPlaying(!isPlaying);
    };

    const nextSong = () => {
        if (isShuffle) {
            setCurrentIndex(Math.floor(Math.random() * songs.length));
        } else {
            setCurrentIndex((prev) => (prev + 1) % songs.length);
        }
        setIsPlaying(true);
    };

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.src = songs[currentIndex].src;
            if (isPlaying) audioRef.current.play().catch(() => { });
        }
    }, [currentIndex]);

    // --- INTERAKSI SOSIAL ---
    const handlePost = () => {
        if (!inputText.trim()) return;
        const newPost = {
            id: Date.now(),
            user: user?.name || "Rony",
            text: inputText,
            likes: 0,
            comments: [],
            time: "Baru saja"
        };
        setPosts([newPost, ...posts]);
        setInputText("");
    };

    const handleLike = (id) => {
        setPosts(posts.map(p => p.id === id ? { ...p, likes: p.likes + 1 } : p));
    };

    const handleComment = (id) => {
        const msg = prompt("Tulis komentar kamu:");
        if (msg) {
            setPosts(posts.map(p => p.id === id ? { ...p, comments: [...p.comments, msg] } : p));
        }
    };

    return (
        <div className="xyrons-mobile-wrapper" style={{
            background: '#111111', // Abu-abu gelap mewah, bukan hitam polos
            minHeight: '100vh',
            paddingBottom: '40px',
            color: '#fff'
        }}>
            <audio ref={audioRef} onEnded={nextSong} />

            {/* RUNNING TEXT - FIXED POSITION (TIDAK IKUT SCROLL) */}
            <div style={{
                background: '#28a745',
                color: '#000',
                fontSize: '10px',
                fontWeight: '900',
                padding: '6px 0',
                textTransform: 'uppercase',
                position: 'sticky',        // Kuncinya di sini
                top: '48px',               // Sesuaikan dengan tinggi navbar kamu
                zIndex: 90,                // Supaya tetap di atas konten main
                borderBottom: '1px solid #000'
            }}>
                <marquee scrollamount="5">
                    🚀 XYRONS COMMUNITY HUB • 30+ AI TOOLS ONLINE • MEDAN - SIHANOUKVILLE CONNECTION • WELCOME {user?.name?.toUpperCase() || "RONY"} • SHARE YOUR AI IDEAS BELOW!
                </marquee>
            </div>

            {/* MAIN CONTENT */}
            <main style={{ padding: '12px', marginTop: '5px' }}>

                {/* HERO SECTION - TULISAN UTAMA */}
                <div style={{ textAlign: 'center', padding: '20px 0 30px' }}>
                    <h1 style={{
                        color: '#28a745',           // Warna hijau dasar
                        fontSize: '20px',           // Ukuran sedikit diperbesar (sebelumnya 20-22px)
                        fontWeight: '900',           // Dibuat paling tebal agar tegas
                        margin: '0',                 // Tetap 0 agar dempet ke running text
                        paddingTop: '50px',          // Jarak halus dari bar hijau
                        fontFamily: "'Inter', sans-serif",
                        letterSpacing: '-0.5px',
                        textTransform: 'uppercase',

                    }}>
                        AI Tools Gratis Terbaik 2026
                    </h1>
                    <p style={{
                        color: '#888',
                        fontSize: '13px',
                        lineHeight: '1.6',
                        maxWidth: '300px',
                        margin: '0 auto'
                    }}>
                        Xyrons Hub adalah platform kumpulan <strong style={{ color: '#bbb' }}>AI tools gratis terbaik</strong> untuk
                        coding, desain, bisnis, dan produktivitas.
                    </p>
                </div>

                {/* B. MUSIC PLAYER (TENGAH) - VERSI RAPI & TUNGGAL DENGAN LOGO BERPUTAR */}
                <div style={{ background: 'linear-gradient(180deg, #111, #000)', borderRadius: '16px', padding: '15px', marginBottom: '20px', border: '1px solid #222' }}>

                    {/* Info Lagu & Logo Berputar */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                        <div style={{ position: 'relative', width: '50px', height: '50px' }}>
                            <img
                                src={songs[currentIndex].cover}
                                alt="cover"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '50%', // Bulat seperti CD
                                    border: isPlaying ? '2px solid #28a745' : '2px solid #333',
                                    objectFit: 'cover',
                                    // Animasi putar jika musik sedang jalan
                                    animation: isPlaying ? 'spin 3s linear infinite' : 'none',
                                    transition: '0.5s'
                                }}
                            />
                            {/* CSS untuk Animasi Spin */}
                            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
                        </div>

                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{songs[currentIndex].title}</div>
                            <div style={{ fontSize: '11px', color: '#28a745' }}>{songs[currentIndex].artist}</div>
                        </div>
                    </div>

                    {/* Tombol Kontrol */}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '25px', alignItems: 'center', marginBottom: '20px' }}>
                        <button onClick={() => setIsShuffle(!isShuffle)} style={{ background: 'none', border: 'none', color: isShuffle ? '#28a745' : '#444', cursor: 'pointer' }}>🔀</button>
                        <button onClick={() => setCurrentIndex((currentIndex - 1 + songs.length) % songs.length)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '20px', cursor: 'pointer' }}>⏮</button>
                        <button onClick={togglePlay} style={{ background: '#28a745', border: 'none', width: '50px', height: '50px', borderRadius: '50%', fontSize: '20px', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {isPlaying ? '⏸' : '▶'}
                        </button>
                        <button onClick={nextSong} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '20px', cursor: 'pointer' }}>⏭</button>
                        <button style={{ background: 'none', border: 'none', color: '#444', cursor: 'not-allowed' }}>🔁</button>
                    </div>

                    {/* KOTAK PENCARIAN (SEARCH) */}
                    <div style={{ display: 'flex', alignItems: 'center', background: '#0d0d0d', borderRadius: '10px', padding: '8px 12px', border: '1px solid #222', marginBottom: '10px' }}>
                        <span style={{ marginRight: '8px' }}>🔍</span>
                        <input
                            type="text"
                            placeholder="Cari lagu..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                            style={{ flex: 1, background: 'transparent', border: 'none', color: '#fff', fontSize: '12px', outline: 'none' }}
                        />
                    </div>

                    {/* DAFTAR PLAYLIST */}
                    <div style={{ maxHeight: '180px', overflowY: 'auto', position: 'relative', borderTop: '1px solid #222', scrollbarWidth: 'none' }}>
                        <div style={{ position: 'sticky', top: 0, background: '#000', padding: '10px 0', fontSize: '11px', color: '#28a745', fontWeight: 'bold', zIndex: 5, borderBottom: '1px solid #111' }}>
                            🎵 PLAYLIST XYRONS HUB
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            {songs
                                .filter(song =>
                                    song.title.toLowerCase().includes(searchQuery) ||
                                    song.artist.toLowerCase().includes(searchQuery)
                                )
                                .map((song, index) => {
                                    const originalIndex = songs.findIndex(s => s.title === song.title);
                                    const isCurrent = currentIndex === originalIndex;

                                    return (
                                        <div
                                            key={index}
                                            onClick={() => {
                                                setCurrentIndex(originalIndex);
                                                setIsPlaying(true);
                                                if (audioRef.current) {
                                                    audioRef.current.pause();
                                                    audioRef.current.load();
                                                    audioRef.current.play().catch(e => console.log("Play error:", e));
                                                }
                                            }}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '12px 10px',
                                                cursor: 'pointer',
                                                background: isCurrent ? 'rgba(40, 167, 69, 0.15)' : 'transparent',
                                                borderLeft: isCurrent ? '4px solid #28a745' : '4px solid transparent',
                                                marginBottom: '4px',
                                                transition: '0.2s',
                                                borderRadius: '4px'
                                            }}
                                        >
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <span style={{ fontSize: '11px', color: isCurrent ? '#28a745' : '#444' }}>
                                                    {isCurrent ? '▶' : index + 1}
                                                </span>
                                                <div style={{ fontSize: '13px', color: isCurrent ? '#fff' : '#ccc', fontWeight: isCurrent ? 'bold' : 'normal' }}>
                                                    {song.title}
                                                </div>
                                            </div>
                                            <div style={{ fontSize: '10px', color: isCurrent ? '#28a745' : '#555' }}>{song.artist}</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
                {/* C. FEED IDE (POSTINGAN) */}
                <div style={{ marginBottom: '30px' }}>
                    {posts.map((post) => (
                        <div key={post.id} style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: '12px', padding: '15px', marginBottom: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                                <div style={{ width: '25px', height: '25px', background: '#28a745', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#000', fontWeight: 'bold' }}>{post.user[0]}</div>
                                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{post.user}</span>
                                <span style={{ fontSize: '10px', color: '#444', marginLeft: 'auto' }}>{post.time}</span>
                            </div>
                            <p style={{ fontSize: '13px', color: '#ccc', marginBottom: '15px' }}>{post.text}</p>

                            <div style={{ display: 'flex', gap: '20px', borderTop: '1px solid #111', paddingTop: '10px' }}>
                                <button onClick={() => handleLike(post.id)} style={{ background: 'none', border: 'none', color: '#28a745', fontSize: '12px' }}>❤️ {post.likes}</button>
                                <button onClick={() => handleComment(post.id)} style={{ background: 'none', border: 'none', color: '#888', fontSize: '12px' }}>💬 {post.comments.length}</button>
                            </div>

                            {/* Daftar Komentar Berderet Turun */}
                            {post.comments.length > 0 && (
                                <div style={{ marginTop: '10px', padding: '10px', background: '#050505', borderRadius: '8px', borderLeft: '2px solid #28a745' }}>
                                    {post.comments.map((c, i) => (
                                        <div key={i} style={{ fontSize: '11px', color: '#aaa', padding: '4px 0', borderBottom: '1px solid #111' }}>
                                            <span style={{ color: '#28a745' }}>User:</span> {c}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* D. GRID AI */}
                {aiCategories.map((group, idx) => (
                    <section key={idx} style={{ marginBottom: '30px' }}>
                        <h3 style={{
                            color: '#28a745',
                            fontSize: '11px',
                            marginBottom: '15px',
                            fontWeight: '900',
                            letterSpacing: '1px',
                            borderLeft: '3px solid #28a745',
                            paddingLeft: '10px'
                        }}>
                            {group.title}
                        </h3>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '12px'
                        }}>
                            {group.data
                                .filter(item => item.name.toLowerCase().includes(searchQuery))
                                .map((tool, i) => (
                                    <a key={i} href={tool.link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                        <div style={{
                                            background: 'linear-gradient(145deg, #151515, #0a0a0a)',
                                            border: '1px solid #1a1a1a',
                                            borderRadius: '16px',
                                            padding: '15px 5px',
                                            textAlign: 'center',
                                            height: '100%', // Supaya semua kotak tingginya sama
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
                                            transition: '0.3s'
                                        }}>
                                            {/* Icon AI dengan Glow Hijau Tipis */}
                                            <div style={{
                                                width: '45px',
                                                height: '45px',
                                                borderRadius: '50%',
                                                margin: '0 auto 10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '1.5px solid #28a745',
                                                background: '#000',
                                                boxShadow: '0 0 10px rgba(40, 167, 69, 0.1)'
                                            }}>
                                                <img src={tool.icon} alt={tool.name} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                                            </div>

                                            {/* Nama AI */}
                                            <div style={{
                                                color: '#fff',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                                marginBottom: '4px'
                                            }}>
                                                {tool.name}
                                            </div>

                                            {/* Deskripsi AI (Tambahan Baru) */}
                                            <div style={{
                                                color: '#777',
                                                fontSize: '8px',
                                                lineHeight: '1.2',
                                                minHeight: '20px',
                                                padding: '0 5px'
                                            }}>
                                                {tool.desc}
                                            </div>

                                            {/* Label Kecil "OPEN" */}
                                            <div style={{
                                                marginTop: '10px',
                                                fontSize: '7px',
                                                color: '#28a745',
                                                fontWeight: '900',
                                                textTransform: 'uppercase',
                                                padding: '2px 8px',
                                                borderRadius: '10px',
                                                background: 'rgba(40, 167, 69, 0.1)',
                                                border: '0.5px solid #28a745'
                                            }}>
                                                Akses AI
                                            </div>
                                        </div>
                                    </a>
                                ))}
                        </div>
                    </section>
                ))}
            </main>


            {/* FOOTER */}
            <footer style={{
                textAlign: 'center',
                padding: '40px 15px 30px',
                background: 'linear-gradient(180deg, #000, #0a0a0a)',
                borderTop: '1px solid #111',
                marginTop: '20px'
            }}>
                <div style={{ fontSize: '18px', fontWeight: '900', color: '#fff', letterSpacing: '2px' }}>
                    XYRONS<span style={{ color: '#28a745' }}>HUB</span>
                </div>
                <div style={{ fontSize: '9px', color: '#444', marginTop: '5px', fontWeight: 'bold' }}>
                    MEDAN • SIHANOUKVILLE • Xyron HUB
                </div>
                <div style={{ width: '30px', height: '2px', background: '#28a745', margin: '15px auto' }}></div>
                <div style={{ fontSize: '9px', color: '#222' }}>
                    © 2026 Developed by {user?.name || 'Rony'}
                </div>
            </footer>
        </div>
    );
}